
const listHistoricoSolicitacao = {
  dataSolicitacao: null,
  empresaUsuarioSolicitou: null,
  nomeUsuarioSolicitou: null,
  situacaoSolicitacao: null
}

const aluno = {
  numeroSolicitacao: null,
  tipoSolicitacao: null,
  cpf: null,
  situacao: null,
  listHistoricoSolicitacao: [listHistoricoSolicitacao],
  motivo: null
}


export default aluno
